import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatearRut } from '../utils/validaciones';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3001` : `https://${window.location.hostname}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const resp = await fetch(`${apiBase}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rut: username, password })
      });
      if (resp.ok) {
        const data = await resp.json();
        localStorage.setItem('user', JSON.stringify(data.user));
        if (data.user.primer_ingreso === 1) {
          navigate('/perfil');
        } else if (data.user.rol === 'supervisor') {
          navigate('/supervisor');
        } else {
          navigate('/dashboard');
        }
      } else {
        const errData = await resp.json();
        setError(errData.error || 'Credenciales inválidas');
      }
    } catch (err) {
      setError('Error de conexión con el servidor MySQL.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Gestor de Equipos</h2>
          <p>Ingrese sus credenciales para acceder al sistema</p>
        </div>

        {error && (
          <div style={{ color: '#dc3545', backgroundColor: '#f8d7da', border: '1px solid #f5c2c7', padding: '10px', borderRadius: '4px', marginBottom: '15px', fontSize: '14px', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label>RUT Autorizado</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onBlur={(e) => setUsername(formatearRut(e.target.value))}
              placeholder="Ej: 12.345.678-9"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div className="form-actions">
            <button type="button" className="forgot-password-btn" onClick={() => alert('Contacte al administrador para restabler su contraseña.')}>¿Olvidó su contraseña?</button>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <span className="spinner"></span> : 'Ingresar al Sistema'}
          </button>
        </form>

        <div className="external-systems">
          <p>Otros Sistemas</p>
          <button
            type="button"
            className="secondary-system-btn"
            onClick={() => window.location.href = `http://${window.location.hostname}:3003`}
          >
            Ir a Gestor de Espacios
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
